<template>
  <div class="newsroom-media-slider-fi">
    <grid-container-fi>
      <div :class="['fi-col-span-full lg:fi-col-start-2', 'md:fi-col-end-12 lg:fi-col-end-12']">
        <div class="newsroom-media-slider-fi__content">
          <div
            v-if="isSlider"
            class="newsroom-media-slider-fi__head"
          >
            <div class="newsroom-media-slider-fi__headline">
              {{ $dict.get('newsroom.Detail-Page.Images-Headline') }}
            </div>

            <div class="newsroom-media-slider-fi__slider-controls">
              <div
                v-if="isSlider"
                :set="
                  (sliders = {
                    forwardDisabled: currentSlide === 0,
                    backDisabled: currentSlide + visibleSlidesCount >= images.length,
                  })
                "
                class="newsroom-media-slider-fi__slider-arrows"
              >
                <span
                  :class="{
                    'newsroom-media-slider-fi__slider-prev': true,
                    'newsroom-media-slider-fi__slider--inactive': sliders.forwardDisabled,
                  }"
                  :aria-disabled="sliders.forwardDisabled"
                  role="button"
                  @click="prevSlide"
                >
                  <arrow-icon />
                </span>
                <span
                  :class="{
                    'newsroom-media-slider-fi__slider-next': true,
                    'newsroom-media-slider-fi__slider--inactive': sliders.backDisabled,
                  }"
                  :aria-disabled="sliders.backDisabled"
                  role="button"
                  @click="nextSlide"
                >
                  <arrow-icon />
                </span>
              </div>
            </div>
          </div>

          <carousel-fi
            v-if="images.length"
            ref="carousel"
            :class="{
              'newsroom-media-slider-fi__slider': true,
              'newsroom-media-slider-fi__slider--no-slider': !isSlider,
            }"
            :settings="sliderSettings"
            theme="media-items"
            no-arrows
            clipped-right
            @after-change="onAfterChange"
          >
            <carousel-slide-fi
              v-for="(image, indexImage) in images"
              :key="indexImage"
              theme="media-items"
            >
              <div class="newsroom-media-slider-fi__slide">
                <media-library-item-fi
                  :item="image"
                  disbale-dialog
                  is-newsroom
                  @show-zoom-dialog="onShowZoomDialog"
                />
              </div>
            </carousel-slide-fi>
          </carousel-fi>
        </div>
      </div>
    </grid-container-fi>
    <media-library-zoom-image-dialog-fi
      ref="mediaLibraryZoomImageDialog"
      :item="item"
      is-newsroom
    />
  </div>
</template>

<script>
import { ArrowIcon, CarouselFi, CarouselSlideFi } from 'atoms';
import GridContainerFi from 'components/grid-fi/GridContainerFi';
import MediaLibraryItemFi from 'components/media-library-item-fi/MediaLibraryItemFi';
import MediaLibraryZoomImageDialogFi from 'components/media-library-zoom-image-dialog-fi/MediaLibraryZoomImageDialogFi';
import breakpointMixin from 'mixins/breakpointMixin';
import mediaLibraryMixin from 'mixins/mediaLibraryMixin';
import screenWidths from 'tailwind/screenWidths';

export default {
  name: 'NewsroomMediaSliderFi',
  components: {
    ArrowIcon,
    CarouselFi,
    CarouselSlideFi,
    GridContainerFi,
    MediaLibraryItemFi,
    MediaLibraryZoomImageDialogFi,
  },
  mixins: [breakpointMixin, mediaLibraryMixin],
  inject: ['fields'],
  data() {
    return {
      currentSlide: 0,
      item: null,
      isMounted: false,
    };
  },
  computed: {
    images() {
      return this.fields?.images;
    },
    sliderSettings() {
      return {
        rewind: false,
        pagination: false,
        perPage: 1,
        perMove: 1,
        destroy: false,
        gap: 24,
        noDrag: 'input, .no-drag',
        breakpoints: {
          [screenWidths.sm]: {
            perPage: 2,
            destroy: false,
          },
          [screenWidths.md]: {
            perPage: 3,
            destroy: false,
          },
          [screenWidths.lg]: {
            perPage: 5,
            destroy: false,
          },
        },
      };
    },
    visibleSlidesCount() {
      return this.isLG ? 5 : 3;
    },
    isSlider() {
      if (!this.isMounted) {
        return false;
      }

      return this.images.length > this.visibleSlidesCount && this.isMD;
    },
  },
  mounted() {
    this.isMounted = true;
  },
  methods: {
    nextSlide() {
      if (this.$refs.carousel) {
        if (this.currentSlide + this.visibleSlidesCount === this.images.length) {
          return;
        }

        this.$refs.carousel.next();
      }
    },
    prevSlide() {
      if (this.$refs.carousel) {
        if (this.currentSlide === 0) {
          return;
        }

        this.$refs.carousel.prev();
      }
    },
    onAfterChange({ newSlideIndex }) {
      this.currentSlide = newSlideIndex;
    },
    onShowZoomDialog(item) {
      this.item = item;
      this.$refs.mediaLibraryZoomImageDialog.show();
    },
  },
};
</script>

<style scoped lang="scss">
@import './newsroom-media-slider-fi';
</style>
